import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {UserSettingsModuleName} from "../utils/names/optionalModuleNames";
import {NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import "./styles/email-settings-selector.scss"
import {SettingsResolver} from "modules/users/resolver/SettingsResolver";
import {getTabName} from "modules/utils/TabNameUtils";

export const UserSettingsConfiguration = new RestrictedRouteModuleConfiguration(
    UserSettingsModuleName,
    [
         UserSettingsModuleName
    ],
    [
        ["/user/sms-settings", {
            template: require("./component/sms-settings/sms_settings_selector/sms-settings-selector.html"),
            controller: "SmsSettingsController",
            controllerAs: "$ctrl",
            resolve: {
                settings: SettingsResolver.smsResolverInstance
            }
        }]
        ,
        ["/user/settings", {
            template: require("./component/email-settings/user_settings_selector/user-settings-selector.html"),
            controller: "UsersSettingsController",
            controllerAs: "$ctrl",
            resolve: {
                settings: SettingsResolver.instance
            }
        }]
    ],
    [
        new NavigationItem({
            title: 'Email Settings',
            href: '#!user/settings',
            activeFunction: routeName => routeName == "/user/settings"
        }),
        new NavigationItem({
            title: 'SMS Settings',
            href: '#!user/sms-settings',
            activeFunction: routeName => routeName == "/user/sms-settings"
        })
    ],
    [UserSettingsModuleName],
    [UserGranredAuthorityName.AI_EMAIL_GENERATE],
    getTabName() + '| User Settings'
);

export default UserSettingsConfiguration;
